import React from "react";
import {
  DialogProps,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Body1,
  DialogActions,
  DialogTrigger,
  Button,
} from "@fluentui/react-components";

import { Playbook } from "@/types/risk-analysis";

export interface ExitPlaybookEditorDialogProps extends Omit<DialogProps, "children"> {
  playbook?: Playbook;
  onAccept: () => void;
}

export function ExitPlaybookEditorDialog({ playbook, onAccept, ...props }: ExitPlaybookEditorDialogProps) {
  return (
    <Dialog {...props}>
      <DialogSurface aria-labelledby={`exit-${playbook?.id}-title`} aria-describedby={`exit-${playbook?.id}-content`}>
        <DialogBody>
          <DialogTitle id={`exit-${playbook?.id}-title`}>Confirm exit</DialogTitle>
          <DialogContent id={`exit-${playbook?.id}-content`}>
            <Body1>
              Are you sure you want to exit the editor? You have unsaved changes for the “
              <b>{playbook?.name || "Untitled"}</b>” playbook.
            </Body1>
            <br />
            <Body1>If you exit now your unsaved changes will be lost.</Body1>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Cancel</Button>
            </DialogTrigger>
            <Button appearance="primary" onClick={onAccept}>
              Exit
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
